// BrandIdentity.js
import React from 'react';
import './BrandIdentity.css';
import logo from './assets/logo.png'; // Make sure your logo is correctly placed

const BrandIdentity = () => {
  return (
    <div className="brand-identity-container">
      <div className="brand-header">
        <img src={logo} alt="Mwangaza Logo" className="brand-logo" />
        <h2>Our Brand Identity</h2>
        <p className="tagline">The meaning behind our logo and vision</p>
      </div>

      <div className="brand-section">
        <h3>🔍 Symbolism in Our Logo</h3>
        <p>
          Our logo is designed with thoughtful elements that reflect the mission and values of Mwangaza Wellness & Medical Centre:
        </p>
        <ul className="symbol-meanings">
          <li>
            <strong>The Cross:</strong> Symbolizes healing, care and trust, aligning with the establishment's commitment to health and well-being.
          </li>
          <li>
            <strong>The Invisible Person:</strong> Represents inclusitivity, individuality, and the holistic approach to wellness emphasizing personal growth and inner balance.
          </li>
          <li>
            <strong>The Leaf:</strong> Denotes nature, sustainability and rejuvenation, reflecting a focus on natural practices and environmental resposibility.
          </li>
        </ul>
      </div>

      <div className="brand-section">
        <h3>🎨 Meaning of Our Logo Colours</h3>
        <ul className="color-meanings">
          <li><strong>Blue:</strong> Evokes trust, calmness and professionalism.</li>
          <li><strong>Green:</strong> Symbolizes growth, vitality and harmony with nature.</li>
          <li><strong>White:</strong> Stands for purity, safety, and professional integrity in our care delivery.</li>
          <li><strong>Red:</strong> Represents life - The central focus of our patient-centred care. It reflects our commitment to placing each individual at the heart of all we do, guided by innovation, compassion and excellence.</li>
        </ul>
      </div>

      <div className="brand-section">
  <h3>💡 Why This Centre Was Founded</h3>
  <h4> A Tribute to Douglas Irimu Kanja</h4>
  <p>
    Mwangaza Wellness and Medical Centre was established in honour of my father, <strong>Douglas Irimu Kanja</strong>, who passed on in 1983. Though his life was short, his values of service, compassion, and community continue to light our path.
  </p>
  <p>
    <strong>Mwangaza</strong>, meaning "light", reflects the warmth, strength, and quiet wisdom he instilled in us — a light we now share through care, healing, and hope.
  </p>
  <p>
    Mwangaza Wellness and Medical Centre is a simple yet lasting tribute to his belief that strong communities are built by empowering people, uplifting others, and nurturing the belief that we each have the power to shape our destiny.
  </p>
  <p>
    <em>Dad, your journey lives on in us.</em>
    <br />
    — <strong>Prof. Grace W. Irimu-Thinwa</strong><br />
    Founder and Clinical Director
  </p>
</div>

    </div>
  );
};

export default BrandIdentity;
